import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IActionableStatus } from 'app/models/complaints/complaints';
import { IAdministrativeComplaintView, IComplaintView } from 'app/models/mainMenu/mainMenu';
import { IReportSelectItems, ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { BusinessService } from 'app/services/business/business.service';
import { ComplaintService } from 'app/services/complaint/complaint.service';
import { ProcessComplaintService } from 'app/services/complaint/processComplaint.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'determineComplaint',
  templateUrl: './determineComplaint.component.html',
  styleUrls: ['./determineComplaint.component.scss']
})

export class DetermineComplaintComponent implements OnInit {

  isActionable: boolean = false;
  nonActionableList: ISelectItems[] = [];
  violationsList: IReportSelectItems[] = [];
  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;
  complaintList: IAdministrativeComplaintView[] = [];
  reasonsList: string[] = [];
  currentComplaintId: number = 0;
  attachmentCount: number = 0;
  complaintView: IComplaintView = {} as IComplaintView;
  fiveDaysAgo: Date = new Date();
  // selectedViolations: string[] = [];


  displayedColumns: string[] = ['complaintId', 'complaintDate', 'complaintStatus',
    'actionable'];
  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.complaintList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public processComplaintService: ProcessComplaintService,
    public adminService: AdminService,
    public sharedService: SharedService,
    private businessService: BusinessService,
    private complaintService: ComplaintService,
    // private modalService: MatDialog,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    isActionable: new UntypedFormControl('false', [Validators.required]),
    reason: new UntypedFormControl('', [Validators.required])
  });

  ngOnInit(): void {
    this.fiveDaysAgo.setDate(this.fiveDaysAgo.getDate() - 5);
    this.getStatuses();
    this.getComplaintData();
    this.reasonsList = [];
    this.nonActionableList = this.sharedService.nonActionableList;
    this.currentComplaintId = this.processComplaintService.complaintId;
  }

  getAdditionalComplaints() {
    this.processComplaintService.getAdditionalComplaints(this.currentComplaint.businessId).subscribe({
      next: response => {
        this.complaintList = response;
        this.dataSource.data = this.complaintList;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get additional complaints list");
      },
    });
  }

  getComplaintData() {
    this.processComplaintService.getComplaintData(this.processComplaintService.complaintId).subscribe({
      next: response => {
        this.currentComplaint = response;
        this.complaintView = this.currentComplaint.initialComplaint;
        this.form.controls['isActionable'].setValue('false');
        this.form.controls['reason'].setValue('');
        this.attachmentCount = this.currentComplaint.files != null ? this.currentComplaint.files.length : 0;
        this.getAdditionalComplaints();
      },
      error: e => {
        this.sharedService.toastr.error("Could not get complaints");
      },
    });
  }

  within5Days(date:Date): boolean {
    // This was done because there is a strange issue with the date object in a interface and NEW one.
    return new Date(date) >= this.fiveDaysAgo;
  }

  getStatuses() {
    this.reportService.getComplaintViolationsList().subscribe({
      next: response => {
        this.violationsList = response.filter(x => x.group.name == 'Active');
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Data");
      },
    });
  }

  cancel() {
    this.sharedService.doRedirect('mainMenu');
  }

  actionableChange(event: string) {
    if (event == 'true') {
      this.form.controls['reason'].removeValidators([Validators.required]);
      this.form.controls['reason'].updateValueAndValidity();
      this.isActionable = true
    }
    else {
      this.form.controls['reason'].setValidators([Validators.required]);
      this.isActionable = false
    }
  }

  gotoComplaint(complaintId: string) {
    this.complaintService.complaintId = +complaintId;
    this.complaintService.complaintTab = 0;
    this.sharedService.doRedirect('complaint/complaint/'+complaintId);
  }

  setActionableStatus() {
    if (this.form.valid) {

      let reason = this.form.controls['reason'].value;
      let model: IActionableStatus = {
        id: this.processComplaintService.complaintId,
        isActionable: this.isActionable,
        reason: reason,
        selectedNatureOfComplaints: this.reasonsList
      };

      this.processComplaintService.setActionableStatus(model).subscribe(
        (result) => {
          if (result) {
            this.sharedService.toastr.success("Complaint status set.");
            this.sharedService.doRedirect('mainMenu');
          }
          else {
            this.sharedService.toastr.error("Complaint status could not be set.");
          }
        },
        error => {
          this.sharedService.toastr.error("Complaint status could not be set.");
        }
      );
    }
  }

  typeOfBusiness(business: string): string {
    return business == null || business == undefined? '': this.sharedService.getBusinessType(business);
  }

  getCounty(county: string): string {
    return this.sharedService.convertCounty(county);
  }

  actionable(actionable: boolean) {
    this.isActionable = true;
  }

  getAttachment(attachmentNumber: number) {
    let file = attachmentNumber == 1 ? this.currentComplaint.files[0] : this.currentComplaint.files[1];
    this.sharedService.getAttachment(file.id).subscribe(
      (result) => {
        this.sharedService.downloadFile(file.name, result);
      },
      error => {
        this.sharedService.toastr.error("Could not get Attachment:" + error.message);
      }
    );
  }

  check(violation: ISelectItems, event: any) {
    if (event.checked) {
      this.reasonsList.push(violation.value);
    }
    else {
      this.reasonsList = this.reasonsList.filter(x => x != violation.value);
    }
  }

  isViolationChecked(violation: IReportSelectItems): boolean {
    return this.reasonsList.includes(violation.value);
  }

  gotoBusiness(businessId: number) {
    this.businessService.businessId = businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
  }

}

